import { KLAGE_MILJOKONTROLL_LIGHTBOX_IMAGE } from "../actions/klager/klageAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];

const klageMiljoKontrollLightboxImageReducer = (
  state = INITIAL_STATE,
  action,
) => CreateNewReducer(state, action, KLAGE_MILJOKONTROLL_LIGHTBOX_IMAGE);

export default klageMiljoKontrollLightboxImageReducer;
